import React, { FC, useMemo } from 'react';
import { ENUM_LIVE_CARD_MENU } from '../menu-config';
import { OrderType } from 'models/order.model';
import AssignRiderModal from './assign-rider-modal';
import CancelTripModal from './cancel-trip-modal';
import ChangeAddressModal from 'components/live-trip-cards/live-trip-modals/change-address-modal';
import FinishOrderModal from './finish-order-modal';
import CompleteTripModal from './complete-trip-modal';
import ConfirmPaymentModal from './confirm-payment-modal';
import DispatchOrderModal from './dispatch-order-modal';
import EscalateOrderModal from './escalate-order-modal';
import PushNotificationModal from './push-notification';
import ReAssignRepModal from './reassign-rep-modal';
import ReassignRiderModal from './reassign-rider-modal';
import RecallOrderModal from './recall-order-modal';
import StartOrderModal from './start-order-modal';
import RequestDeliveryFromShipbubbleModal from './request-delivery-from-shipbubble-modal';
import SwitchToPickupModal from './switch-to-pickup-modal';
import UnassignRiderModal from './unassign-rider-modal';
import KitchenSurgeModal from './kitchen-surge-modal';
import UpdateSurgeModal from './update-surge-modal';
import ReassignDeliveryPartnerModal from './reassign-delivery-partner';

const LiveTripModals: FC<{
  activeMenu: { order?: OrderType; menuKey?: ENUM_LIVE_CARD_MENU };
  onClose: () => void;
}> = ({ activeMenu, onClose }) => {
  const LiveCardModalComponent = useMemo(() => {
    const { menuKey, order } = activeMenu;
    if (!menuKey || !order) return null;

    const mapping: Record<ENUM_LIVE_CARD_MENU, JSX.Element> = {
      [ENUM_LIVE_CARD_MENU.ASSIGN_RIDER]: <AssignRiderModal show order={order} onClose={onClose} />,
      [ENUM_LIVE_CARD_MENU.CANCEL_TRIP]: <CancelTripModal show order={order} onClose={onClose} />,
      [ENUM_LIVE_CARD_MENU.CHANGE_ADDRESS]: (
        <ChangeAddressModal show order={order} onClose={onClose} />
      ),
      [ENUM_LIVE_CARD_MENU.COMPLETE_ORDER]: (
        <FinishOrderModal show order={order} onClose={onClose} />
      ),
      [ENUM_LIVE_CARD_MENU.COMPLETE_TRIP]: (
        <CompleteTripModal show order={order} onClose={onClose} />
      ),
      [ENUM_LIVE_CARD_MENU.CONFIRM_PAYMENT]: (
        <ConfirmPaymentModal show order={order} onClose={onClose} />
      ),
      [ENUM_LIVE_CARD_MENU.DISPATCH_ORDER]: (
        <DispatchOrderModal show order={order} onClose={onClose} />
      ),
      [ENUM_LIVE_CARD_MENU.ESCALATE_ORDER]: (
        <EscalateOrderModal show order={order} onClose={onClose} />
      ),
      [ENUM_LIVE_CARD_MENU.PUSH_NOTIFICATIONS]: (
        <PushNotificationModal show order={order} onClose={onClose} />
      ),
      [ENUM_LIVE_CARD_MENU.REASSIGN_REP]: <ReAssignRepModal show order={order} onClose={onClose} />,
      [ENUM_LIVE_CARD_MENU.REASSIGN_RIDER]: (
        <ReassignRiderModal show order={order} onClose={onClose} />
      ),
      [ENUM_LIVE_CARD_MENU.RECALLED_ORDER_CS]: (
        <RecallOrderModal show order={order} onClose={onClose} />
      ),
      [ENUM_LIVE_CARD_MENU.RECALL_ORDER]: (
        <RecallOrderModal show order={order} onClose={onClose} kitchen />
      ),
      [ENUM_LIVE_CARD_MENU.REQUEST_DELIVERY_FROM_SHIPBUBBLE]: (
        <RequestDeliveryFromShipbubbleModal show order={order} onClose={onClose} />
      ),
      [ENUM_LIVE_CARD_MENU.START_ORDER]: <StartOrderModal show order={order} onClose={onClose} />,
      [ENUM_LIVE_CARD_MENU.SWITCH_TO_PICKUP]: (
        <SwitchToPickupModal show order={order} onClose={onClose} />
      ),
      [ENUM_LIVE_CARD_MENU.SWITCH_TO_DELIVERY]: (
        <SwitchToPickupModal show order={order} onClose={onClose} />
      ),
      [ENUM_LIVE_CARD_MENU.UNASSIGN_RIDER]: (
        <UnassignRiderModal show order={order} onClose={onClose} />
      ),
      [ENUM_LIVE_CARD_MENU.UPDATE_KITCHEN_SURGE]: (
        <KitchenSurgeModal show order={order} onClose={onClose} />
      ),
      [ENUM_LIVE_CARD_MENU.UPDATE_SURGE]: <UpdateSurgeModal show order={order} onClose={onClose} />,
      [ENUM_LIVE_CARD_MENU.CHANGE_DELIVERY_PARTNER]: (
        <ReassignDeliveryPartnerModal show order={order} onClose={onClose} />
      )
    };

    return mapping[menuKey];
  }, [activeMenu]);

  return LiveCardModalComponent;
};

export default LiveTripModals;
